// extracted by mini-css-extract-plugin
module.exports = {"book-button":"style_book-button--2YrkQJKK","bookButton":"style_book-button--2YrkQJKK","light":"style_light--3thYj5o1","dark":"style_dark--3_J0-v0L","text":"style_text--3nIT0VI1"};